// @flow

import { resolve, reject } from 'redux-optimist-promise';
import { fetch, clear } from 'Store/member-space/constants.helper';

const PRE_PAYMENT_DETAILS = 'PRE_PAYMENT/DETAILS';
const PRE_PAYMENT_PAYLOAD_DATAS = 'PRE_PAYMENT/PAYLOAD_DATAS';

export const FETCH_PRE_PAYMENT_DETAILS = fetch(PRE_PAYMENT_DETAILS);
export const FETCH_PRE_PAYMENT_DETAILS_RESOLVED = resolve(FETCH_PRE_PAYMENT_DETAILS);
export const FETCH_PRE_PAYMENT_DETAILS_REJECTED = reject(FETCH_PRE_PAYMENT_DETAILS);
export const CLEAR_PRE_PAYMENT_DETAILS = clear(PRE_PAYMENT_DETAILS);

export const SET_PRE_PAYMENT_PROVIDER = 'SET_PRE_PAYMENT_PROVIDER';
export const SET_PRE_PAYMENT_PAYMENT_METHOD_ID = 'SET_PRE_PAYMENT_PAYMENT_METHOD_ID';
export const SET_PRE_PAYMENT_PAYMENT_METHOD_CONDITION_ID =
  'SET_PRE_PAYMENT_PAYMENT_METHOD_CONDITION_ID';
export const CLEAR_PRE_PAYMENT_BUTTON = 'CLEAR_PRE_PAYMENT_BUTTON';

export const FETCH_PRE_PAYMENT_PAYLOAD_DATAS = fetch(PRE_PAYMENT_PAYLOAD_DATAS);
export const FETCH_PRE_PAYMENT_PAYLOAD_DATAS_RESOLVED = resolve(FETCH_PRE_PAYMENT_PAYLOAD_DATAS);
export const FETCH_PRE_PAYMENT_PAYLOAD_DATAS_REJECTED = reject(FETCH_PRE_PAYMENT_PAYLOAD_DATAS);
export const CLEAR_PRE_PAYMENT_PAYLOAD_DATAS = clear(PRE_PAYMENT_PAYLOAD_DATAS);
